export const TickCircle = (props: any) => (
  <svg width="15" height="15" fill="none" {...props}>
    <path
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.694 3.175A6.262 6.262 0 0 1 7.5 2.906a5.417 5.417 0 0 1 5.419 5.419 5.417 5.417 0 0 1-5.42 5.419 5.417 5.417 0 0 1-5.418-5.419c0-1.112.338-2.15.913-3.012M4.919 3.325 6.725 1.25M4.919 3.324l2.106 1.538"
    />
    <path
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.5 8.877 6.623 10l3-3"
    />
  </svg>
);
